"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5.92 7 4.79 9l1.13 2h2.14l1.13-2-1.13-2zm5.02 9L9.8 18.02 10.92 20h2.16l1.12-1.98L13.06 16zm2.12-2 1.13-2-1.13-2h-2.12l-1.13 2 1.13 2zm-7.14-1-1.13 2 1.13 2h2.14l1.13-2-1.13-2zm10.02-6-1.13 2 1.13 2h2.14l1.13-2-1.13-2zm-5.02-3L9.8 5.98 10.94 8h2.12l1.14-2.02L13.08 4zm5.02 9-1.13 2 1.13 2h2.14l1.13-2-1.13-2z",
  opacity: ".3"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m21.5 9-2.25-4h-3.31l-1.69-3h-4.5L8.06 5H4.75L2.5 9l1.69 3-1.69 3 2.25 4h3.31l1.69 3h4.5l1.69-3h3.31l2.25-4-1.69-3 1.69-3zM8.06 17H5.92L4.8 15l1.12-2h2.14l1.12 2-1.12 2zm0-6H5.92L4.79 9l1.12-2h2.14l1.12 2-1.11 2zm5.02 9h-2.16L9.8 18.02 10.94 16h2.12l1.13 2.02L13.08 20zm-3.27-8 1.12-2h2.12l1.12 2-1.12 2h-2.12l-1.12-2zm3.25-4h-2.12L9.8 5.98 10.92 4h2.16l1.12 1.98L13.06 8zm5.02 9h-2.14l-1.12-2 1.12-2h2.14l1.12 2-1.12 2zm0-6h-2.14l-1.12-2 1.12-2h2.14l1.12 2-1.12 2z"
}, "1")], 'HiveTwoTone');
exports.default = _default;